import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  GET_REPEAT_ORDER_LIST_ENDPOINT,
  DELETE_REPEAT_ORDER_ENDPOINT,
  GET_REPEAT_ORDER_COUNT_ENDPOINT,
  GET_REPEAT_ORDER_PATIENT_LIST_ENDPOINT,
  CREATE_REPEAT_ORDER_ENDPOINT,
  UPDATE_REPEAT_ORDER_ENDPOINT,
  GET_REPEAT_ORDER_SEARCH_ENDPOINT,
  GET_SINGLE_REPEAT_ORDER_ENDPOINT,
  UPDATE_REPEAT_ORDER_DATE_ENDPOINT,
  ADD_MEDICATION_PATINET_ENDPOINT,
  GET_REPEATORDER_TO_ORDERPAD_ENDPOINT,
  UPDATE_REPEAT_ORDER_NOTE_ENDPOINT,
  DELETE_REPEAT_ORDER_NOTE_ENDPOINT,
  GET_OOS_ORDER_LIST_ENDPOINT,
  GET_GLOBAL_SETTING_ENDPOINT,
  CREATE_MULTI_ORDER_ENDPOINT,
  STATUS_ENDPOINT,
  UPDATE_PRN_ENDPOINT,
  GET_GLOBAL_SETTING_ACCESS,
  PATIENT_CREATE_MULTIORDER,
  NEXT_CYCLE_DAY,
  ORDER_COUNT_TYPE,
  Get_Today_List_Count,
  Get_Today_List,
  Create_Bulk_Order_Today,
} from "./endpoints";

//Get Repeat order List
export const getRepeatOrderListAPI = (payload) => {
  return API.post(GET_REPEAT_ORDER_LIST_ENDPOINT, payload);
};

// Create Repeat Order
export const createRepeatOrderAPI = (payload) => {
  return API.post(CREATE_REPEAT_ORDER_ENDPOINT, payload);
};

//Update Repeat Order
export const updateRepeatOrderAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_REPEAT_ORDER_ENDPOINT, { order_id: id }),
    payload
  );
};

//Single Repeat Order
export const getSingleRepeatOrder = (id) => {
  return API.get(
    generateDynamicEndpoint(GET_SINGLE_REPEAT_ORDER_ENDPOINT, { order_id: id })
  );
};

//Search Repeat Order
export const getSearchRepeatOrder = (id) => {
  return API.get(
    generateDynamicEndpoint(GET_REPEAT_ORDER_SEARCH_ENDPOINT, { order_id: id })
  );
};

//Delete Repeat order
export const deleteRepeatOrderAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_REPEAT_ORDER_ENDPOINT, { order_id: id })
  );
};

//Get Repeat order List
export const getRepeatOrderCountAPI = (payload) => {
  return API.get(GET_REPEAT_ORDER_COUNT_ENDPOINT, payload);
};

//Repeat over drop-down Field List
export const getRepeatOrderPatientListAPI = (payload) => {
  return API.post(GET_REPEAT_ORDER_PATIENT_LIST_ENDPOINT, payload);
};

//Update Date
export const updateDateAPI = (payload) => {
  return API.post(UPDATE_REPEAT_ORDER_DATE_ENDPOINT, payload);
};

//Add Patient Medication
export const addPatientMedicationAPI = (payload) => {
  return API.post(ADD_MEDICATION_PATINET_ENDPOINT, payload);
};

//Update global setting
export const updateGlobalSettingAPI = (payload) => {
  return API.put(
    `/general-settings/update`,
    payload
    // {
    //   // /${payload.gs_id}`, {
    //   gs_short_code: payload.gs_short_code,
    //   gs_value: payload.gs_value,
    // }
  );
};

//Get global setting
export const repeatorderToOrderpadAPI = (payload) => {
  return API.post(GET_REPEATORDER_TO_ORDERPAD_ENDPOINT, payload);
};

//Update Repeat Order note
export const updateRepeatOrderNoteAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_REPEAT_ORDER_NOTE_ENDPOINT, {
      order_id: id,
    }),
    payload
  );
};

//Delete Repeat order note
export const deleteRepeatOrderNoteAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_REPEAT_ORDER_NOTE_ENDPOINT, { order_id: id })
  );
};

//Get OOS order List
export const getOosOrderListAPI = (payload) => {
  return API.post(GET_OOS_ORDER_LIST_ENDPOINT, payload);
};

//Get global setting
export const globalSettingAPI = () => {
  return API.get(GET_GLOBAL_SETTING_ENDPOINT);
};
export const globalSettingAccessApi = () => {
  return API.get(GET_GLOBAL_SETTING_ACCESS);
};

// Create Multi Order
export const createMultiOrderAPI = (payload) => {
  return API.post(CREATE_MULTI_ORDER_ENDPOINT, payload);
};

export const statusUpdateAPI = (id, payload) => {
  return API.put(generateDynamicEndpoint(STATUS_ENDPOINT, { id: id }), payload);
};

export const updatePRNAPI = (payload) => {
  return API.post(UPDATE_PRN_ENDPOINT, payload);
};

export const patientMultiOrderAPI = (payload) => {
  return API.post(PATIENT_CREATE_MULTIORDER, payload);
};

export const nextOrderCycleAPI = (payload) => {
  return API.post(NEXT_CYCLE_DAY, payload);
};

export const orderCountTypeAPI = (payload) => {
  return API.post(ORDER_COUNT_TYPE, payload);
};

export const bulkOrderCountAPI = (payload) => {
  return API.post(Get_Today_List_Count, payload);
};

export const getBulkOrderListAPI = (payload) => {
  return API.post(Get_Today_List, payload);
};

export const createBulkOrderAPI = (payload) => {
  return API.post(Create_Bulk_Order_Today, payload);
};